var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentGlyph = function SvgDocumentGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.956C10 13.314 9.388 14 8.157 14H1.843C.613 14 0 13.32 0 11.956V2.05C0 .692.618 0 1.843 0h2.729v4.793c0 .836.363 1.234 1.124 1.234H10v5.93Zm-.506-7.723c.251.316.403.574.435.839H6.217c-.194 0-.288-.116-.288-.349V.072c.22.045.434.232.68.542l2.885 3.62Z",
    fill: "currentColor"
  })));
};
export default SvgDocumentGlyph;